<template>
  <div
    v-if="theme && theme.page_banner_visible && theme.page_banner_background_image"
    :style="`background-image: url(${theme.page_banner_background_image}) !important; background-repeat: no-repeat;
                  background-size: cover;
                  background-position: 50%;`"
    class="store-hero position-relative border-bottom"
  >
    <div v-if="theme && theme.page_banner_background_image" class="w-100 h-100 store-hero-banner row m-0 align-items-center justify-content-center">
      <div class="col-md-4 offset-md-4 align-items-center justify-content-center">
        <div class="flex-contain">
          <img v-if="theme && theme.page_banner_center_image" class="img-fluid" style="max-height: 185px" :src="theme.page_banner_center_image" />
        </div>
      </div>
      <div class="col-md-4">
        <div class="flex-contain">
          <img v-if="theme && theme.page_banner_right_image" class="img-fluid" style="max-height: 185px" :src="theme.page_banner_right_image" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    theme: { type: Object, required: true },
  },
};
</script>

<style scoped>
.flex-contain {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
